import "./index.css";

export const ProveedoresInstantaneos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Administrar Proveedores Instantaneos</h1>
      </div>
    </div>
  );
};
